import { CalendarOutlined, DashboardOutlined, UsergroupAddOutlined, UserSwitchOutlined, DollarOutlined } from "@ant-design/icons";
import { BsQrCode } from "react-icons/bs";
import { FaMoneyBill } from "react-icons/fa";
import { FaGear } from "react-icons/fa6";
import { FiCoffee } from "react-icons/fi";
import { GrServices } from "react-icons/gr";
import { TbMenuOrder } from "react-icons/tb";

export const providerMenu = [
    {
        key: '/provider',
        label: "Asosiy",
        icon: <DashboardOutlined />,
    },
    {
        key: '/provider/services',
        label: "Xizmatlar",
        icon: <GrServices />,
    },
    {
        key: '/provider/orders',
        label: "Buyurtmalar",
        icon: <TbMenuOrder />,
    },
    {
        key: '/provider/foods',
        label: "Taomlar",
        icon: <BsQrCode />,
    },
    {
        key: '/provider/moliya',
        label: "Moliya",
        icon: <FaMoneyBill />,
    },
    {
        key: '/provider/clients',
        label: "Mijozlar",
        icon: <UserSwitchOutlined />,
    },
    {
        key: '/provider/employees',
        label: "Xodimlar",
        icon: <UsergroupAddOutlined />,
    },
    {
        key: '/provider/calendar',
        label: "Kalendar",
        icon: <CalendarOutlined />,
    },
    {
        key: '/provider/tarif',
        label: "Tarif",
        icon: <DollarOutlined />,
    },
    {
        key: '/provider/settings',
        label: "Sozlamalar",
        icon: <FaGear />,
    },
]